import { Alert } from '@one-thd/sui-atomic-components';
import React from 'react';
import '../../../styles/order-details.scss';

// prop is not required if we are only using generic error message

const errorMessage =
  'We were unable to retrieve your shipment details. Refresh the page and try again.'; // move to constant file.

export const TrackShipmentError = () => {
  return (
    <div className="track-shipment-alert">
      <Alert status="error" size="large">
        {errorMessage}{' '}
      </Alert>
    </div>
  );
};
